// NPM
import { useRecoilState } from 'recoil';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import _, { isNil, isEmpty } from 'lodash';
import {Helmet} from "react-helmet";

// ATOM
import { profileInfoAtom, passwordInfoAtom } from 'Recoil/profile.atom';
import {authPassportAtom} from 'Recoil/auth.atom';

// HELPER
import { getWithExpiry } from 'Helpers/index';
import { toaster } from 'Helpers/toaster';

// ANT COMPONENT
import  { BasicModal, Button } from '@life-line-lab/components-react';

// SERVICE
import { fetchUserProfile, updateUserProfile } from 'Services/profile.services';
import {authChangePassword} from 'Services/auth.services';

// COMPONENT
import ProfileForm from 'Components/profile/profile-details';
import changePasswords from 'Components/profile/profile-details/change-passwords';

// HOOK
import useSession from 'Hooks/session.hook';

// STYLE
import './profile.scss';


const ProfilePage = () => {
    const history = useHistory();
    const { t } = useTranslation();
    const [ profileState, setProfileState ] = useRecoilState<any>(profileInfoAtom);
    // const [ passwordState, setPasswordState ] = useRecoilState<any>(passwordInfoAtom);
    // // const [authPassport, setAuthPassport] = useRecoilState<any>(authPassportAtom);
    // const[passwordChangeModalVisible,setPasswordChangeModalVisible] = useState(false);

//     const handleOk = async (currentPassword:string, newPassword:string) => {
        
//         try {
//             setPasswordState({
//                 ...passwordState,
//                 status: {
//                     ...passwordState.status, fetch: 'loading'
//                 }
//             });
//             const session = useSession();
//             if (isEmpty(session)) {
//                 history.push('/login');
//                 return;
//             }
//             const userPID = session.roles[0].data.pid;
//             const response = await authChangePassword(userPID,currentPassword,newPassword);
            
//             if (response) {
//                 setPasswordState({
//                     ...passwordState,
//                     status: {
//                         ...passwordState.status, fetch: 'success'
//                     },
//                     data: response
//                 }
//                 ) //toaster for success
//                 toaster(
//                   'success',
//                   <div dangerouslySetInnerHTML={{
//                       __html: t('txt.resetPasswordSuccess')
//                   }} />
//                 );
//             }else {
//                 toaster(
//                     'error',
//                     <div dangerouslySetInnerHTML={{
//                     __html: ('Current password is wrong, please try again.')
//                     }} />
//                 )

//                 setProfileState({
//                     ...passwordState,
//                     status: {
//                         ...passwordState.status, fetch: 'error'
//                     }
//                 });
//             }
        
//         setPasswordChangeModalVisible(false);
        
//       }
//     catch (err) {
//         toaster(
//             'error',
//             <div dangerouslySetInnerHTML={{
//             __html: ('An error occurred while retrieving your information. Please refresh the page or contact us for help')
//             }} />
//         )
//     }
// }
    

    
//     const handleCancel = () => {
//         setPasswordChangeModalVisible(false);
//       };

    // const onClick = () => {
    //     setPasswordChangeModalVisible(true)
    //     console.log(passwordChangeModalVisible)
    // }

    useEffect(() => {
        const session = useSession();
        if (isEmpty(session)) {
            history.push('/login');
            return;
        }
        const profileID = session.profile._id;
        fetchProfile(profileID);
    },[])

    // function getBase64Image(img) {
    //     var dataURL = toDataURL
    // }

    const fetchProfile = async (profileID: string) => {
        try {
            setProfileState({
                ...profileState,
                status: {
                    ...profileState.status, fetch: 'loading'
                }
            });

            const response = await fetchUserProfile(profileID);
        
            if (isNil(response.error)) {
                setProfileState({
                    ...profileState,
                    status: {
                        ...profileState.status, fetch: 'success'
                    },
                    data: response
                });
            }else {
                toaster(
                    'error',
                    <div dangerouslySetInnerHTML={{
                    __html: ('An error occurred while retrieving your information. Please refresh the page or contact us for help')
                    }} />
                )

                setProfileState({
                    ...profileState,
                    status: {
                        ...profileState.status, fetch: 'error'
                    }
                });
            }

        }
        catch (err) {
            toaster(
                'error',
                <div dangerouslySetInnerHTML={{
                __html: ('An error occurred while retrieving your information. Please refresh the page or contact us for help')
                }} />
            )
        }
        
    }

    const handleUpdate = async(data: any) => {
        try {
            setProfileState({
                ...profileState,
                status: {
                    ...profileState.status, update: 'loading'
                }
            });

            // const response = await updateUserProfile(_.omit(data, ['logoBase64String']));
            const response = await updateUserProfile(data);
            if (!isNil(response)) {
                setProfileState({
                    ...profileState,
                    status: {
                        ...profileState.status, update: 'success'
                    },
                    data: {...response}
                });
                fetchProfile(data.profileID);
                toaster(
                    'success',
                    <div dangerouslySetInnerHTML={{
                    __html: (t('txt.profileUpdateSuccess'))
                    }} />
                )
            }
            else {
                setProfileState({
                    ...profileState,
                    status: {
                        ...profileState.status, update: 'error'
                    },
                    data: {...profileState.data}
                });

                toaster(
                    'error',
                    <div dangerouslySetInnerHTML={{
                    __html: (t('txt.profileUpdateFailed'))
                    }} />
                )
            }
        }
        catch(err) {
            toaster(
                'error',
                <div dangerouslySetInnerHTML={{
                __html: ('Please ensure the information in "My Profile" is complete before continuing.')
                }} />
            )
        }
    }
    return(
    <React.Fragment>
        <Helmet>
        <title>
            Profile
        </title>
        </Helmet>
        <div className="profile-page">
            
            <ProfileForm data = {profileState.data} 
            // extraActions={(
            //     <Button
            //     className='button--right'
            //     type="primary"
            //     size="middle"
            //     label={t('action.changePassword')}
            //     onClick={onClick}
            // /> )}
                onSubmit={handleUpdate} />
            
            {/* <BasicModal
                title= "Edit Password"
                isOpen= {passwordChangeModalVisible} 
                isClosable= {true}
                isMaskClosable= {true}
                onClose={handleCancel}
                bodyStyle= {{ height: 500 }} width={500} 
                // [key= string]= any;
                > */}
        
                {/* <changePasswords.PasswordForm
                    onSubmit={handleOk} 
                    onCancel={handleCancel}/>
            </BasicModal> */}
        </div>
    </React.Fragment>
    )
}

export default ProfilePage;
